<header>
  <app-top-bar></app-top-bar>

  @if (categories$ | async; as categories) {
    <div class="top-navbar">
      <div class="container">
        <nav class="navbar navbar-expand-lg">
          <button
            class="navbar-toggler"
            title="{{ 'Toggle navigation' | translate | async }}"
            (click)="toggleMenu()"
          >
            <img
              loading="lazy"
              width="30"
              src="/assets/images/header-icons/menu-icon.png"
              alt=""
            />
          </button>
          <a class="navbar-brand" [sRouterLink]="'home'">
            <img
              loading="lazy"
              [src]="logo.url"
              alt="{{ logo.title }}"
              [attr.width]="logo.width || '145'"
              [attr.height]="logo.height || '38'"
            />
          </a>
          <div class="searchbar-collapse">
            <app-top-search class="w-100"> </app-top-search>
          </div>
          <ul class="navbar-nav navbar-actions align-items-center">
            <li class="customer-item">
              <app-customer-menu></app-customer-menu>
            </li>
            @if (isShowWishlistNavigation) {
              <li class="wishlist-item" (click)="redirectToWishlist()">
                <mat-icon svgIcon="heart-outline"></mat-icon>
              </li>
            }
            <li class="cart-item">
              <app-top-cart></app-top-cart>
            </li>
          </ul>
        </nav>
      </div>
      <div class="sidebar-nav" [ngClass]="!menuHidden ? 'open' : ''">
        <div
          class="nav-title d-flex justify-content-between align-items-center align-content-center"
        >
          <a class="navbar-brand" routerLink="#" (click)="toggleMenu()">
            <img loading="lazy" [src]="logo.url" alt="{{ logo.title }}" />
          </a>
          <button class="navbar-toggler" (click)="toggleMenu()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <app-header-main-menu [categories]="categories" (childEvent)="toggleMenu()">
        </app-header-main-menu>

        <app-top-bar-menu (itemClicked)="toggleMenu()"></app-top-bar-menu>

        <div class="dropdowns-bar">
          <div class="dropdowns-bar__item">
            <app-store-switcher (childEvent)="toggleMenu()"></app-store-switcher>

            <app-currency-dropdown (childEvent)="toggleMenu()"></app-currency-dropdown>
          </div>
        </div>
      </div>
      <div
        class="sidebar-overlay"
        [ngClass]="!menuHidden ? 'open' : ''"
        (click)="toggleMenu()"
      ></div>
    </div>
    <div class="bottom-navbar">
      <div class="container">
        <nav class="navbar navbar-expand-lg">
          <app-header-main-menu
            [categories]="categories"
            class="navbar-nav d-none d-lg-block"
            (childEvent)="toggleMenu()"
          >
          </app-header-main-menu>
        </nav>
      </div>
    </div>
  }
</header>
